import AbsenceUser from 'features/absence/absenceUser';
import { useTitle } from '../helpers';

/**
 * @page Absence user page
 */
const AbsenceUserPage = () => {
  useTitle('Неявки');

  return (
    <div>
      <h3>Страница информации о неявке</h3>
      <AbsenceUser />
    </div>
  );
};

export default AbsenceUserPage;
